import foundationForm from "./foundation-form.js";
import foundationTracking from "./foundation-tracking.js";

/**
 * The payload localized by the plugin's PHP side (see
 * Config\Foundation_Config).
 */
type FoundationPayload = {
	activeFormIds: string[];
	formId: string;
	locale: string;
	region: string;
};

const TRACKED_SELECTOR = `#foundation-prizes, .rt-foundation-form, [data-rt-track="foundation-apply"]`;

declare const fd_RTFOUNDATION_Form_Config_ajax_obj:
	| undefined
	| { payload: FoundationPayload };

const payload = fd_RTFOUNDATION_Form_Config_ajax_obj?.payload;

if (payload && document.querySelector(".rt-foundation-form")) {
	foundationForm();
}

if (payload && document.querySelector(TRACKED_SELECTOR)) {
	foundationTracking({
		activeFormIds: payload.activeFormIds,
		locale: payload.locale,
		region: payload.region,
	});
}
